import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updatePackagePrice } from "../axios";
import { setCustomerPackageDiscountPercentage } from "../../redux/actions/actions";
import {
  calculateAdminPackageBeforeDiscountAmount,
  calculateDiscountedAmount,
} from "./PackageShowcase/commonFunction";
import "./AdminPackage.css";

function Policydetails({ policyData }) {
  const dispatch = useDispatch();
  const adminPackages = useSelector((state) => state.adminPackageCart.adminPackages);

  const defaultAmount = calculateAdminPackageBeforeDiscountAmount(adminPackages);
  const initialDiscount = policyData?.discount_percentage || 0;
  const initialSellingPrice = calculateDiscountedAmount(defaultAmount, initialDiscount);

  const [packageID] = useState(policyData?.id);
  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    defaultValues: {
      sellingPrice: policyData?.selling_price || initialSellingPrice,
      discountPercentage: initialDiscount,
      offer_description: policyData?.offer_description || "",
    },
  });

  useEffect(() => {
    setValue("sellingPrice", initialSellingPrice);
    setValue("discountPercentage", initialDiscount);
  }, [policyData, initialSellingPrice, initialDiscount, setValue]);

  const handleSellingPriceChange = (value) => {
    const price = parseFloat(value) || 0;
    const discount = ((defaultAmount - price) / defaultAmount) * 100;
    setValue("discountPercentage", discount.toFixed(2), { shouldValidate: true });
  };

  const handleDiscountPercentageChange = (value) => {
    const discount = parseFloat(value) || 0;
    const price = defaultAmount - (defaultAmount * discount) / 100;
    setValue("sellingPrice", price.toFixed(2), { shouldValidate: true });
  };

  const onSubmit = async (data) => {
    try {
      await updatePackagePrice(packageID, data.sellingPrice, data.discountPercentage, data.offer_description, defaultAmount);
      dispatch(setCustomerPackageDiscountPercentage(data.discountPercentage));
      alert("Price is updated successfully.");
    } catch (error) {
      console.error("Error updating package price:", error);
      alert("Error updating package price. Please try again.");
    }
  };

  return (
    <div className="summaryWrapper">
      <div className="summaryContainer">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="summaryCardWrapper">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="form-group col-lg-4">
                    <label>Default Amount</label>
                    <input
                      type="text"
                      className="floating-label-field"
                      value={defaultAmount}
                      readOnly
                    />
                  </div>

                  <div className="form-group col-lg-4">
                    <label>Selling Price</label>
                    <input
                      type="text"
                      className="floating-label-field"
                      {...register("sellingPrice", {
                        required: "Selling price is required",
                        min: { value: 0, message: "Cannot be less than 0" },
                        max: { value: defaultAmount, message: `Cannot exceed ${defaultAmount}` },
                      })}
                      onChange={(e) => handleSellingPriceChange(e.target.value)}
                    />
                    {errors.sellingPrice && <span className="text-danger">{errors.sellingPrice.message}</span>}
                  </div>

                  <div className="form-group col-lg-4">
                    <label>Discount Percentage</label>
                    <input
                      type="text"
                      className="floating-label-field"
                      {...register("discountPercentage", {
                        required: "Discount percentage is required",
                        min: { value: 0, message: "Cannot be less than 0" },
                        max: { value: 100, message: "Cannot exceed 100" },
                      })}
                      onChange={(e) => handleDiscountPercentageChange(e.target.value)}
                    />
                    {errors.discountPercentage && <span className="text-danger">{errors.discountPercentage.message}</span>}
                  </div>
                </div>

                <div className="form-group">
                  <label>Offer Details</label>
                  <textarea
                    className="floating-label-field textarea"
                    {...register("offer_description")}
                    placeholder="Add any notes here..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-success mt-3">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Policydetails;
